import styled from 'styled-components'

import { Text, Stack } from '@doordash/design-language'

export const PaddedLabel = styled(Text)`
  padding: 4px 0 0 4px;
`
export const SpreadStack = styled(Stack)`
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
`
